import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { Chain } from "../components/data";

export interface ChainState {
  chain: Chain;
}

const initialState: ChainState = {
  chain: Chain.POL,
};

export const chainSlice = createSlice({
  name: "chain",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setChain: (state: ChainState, action: PayloadAction<Chain>) => {
      state.chain = action.payload;
    },
  },
});

export const { setChain } = chainSlice.actions;

export const selectChain = (state: RootState) => state.chain.chain;
export default chainSlice.reducer;
